import { type ComponentProps, memo } from "react";

import {
  CartLineQuantity,
  type CartLineQuantityAdjustButton,
} from "@shopify/hydrogen-react";

import { CartGiftLineQuantityAdjustButton } from "@cart/CartGiftLineQuantityAdjustButton";
import { Icon } from "@react/components/Icon";
import { tw } from "classnames";

const styles = {
  container: tw(
    "text-primary",
    "inline-flex",
    "items-center",
    "gap-x-3",
    "rounded-sm",
    "border",
    "border-solid",
    "border-interactive-disabled-button"
  ),
  cartLineQuantity: tw(
    "font-calibre",
    "antialiased",
    "leading-snug",
    "text-xs"
  ),
  button: tw(
    "inline-flex",
    "px-1",
    "py-2",
    "bg-transparent",
    "border-0",
    "cursor-pointer"
  ),
  icon: tw("w-4", "h-4", "inline-flex", "items-center"),
};

type Props = {
  onQuantityChange: ({
    adjust,
    quantity,
  }: {
    adjust: ComponentProps<typeof CartLineQuantityAdjustButton>["adjust"];
    quantity: number;
  }) => void;
};

const CartItemQuantitySelectorViewBase = ({ onQuantityChange }: Props) => {
  return (
    <div className={styles.container}>
      <CartGiftLineQuantityAdjustButton
        adjust="decrease"
        className={styles.button}
        onQuantityChange={onQuantityChange}
      >
        <Icon className={styles.icon} name="minus" />
      </CartGiftLineQuantityAdjustButton>
      <CartLineQuantity className={styles.cartLineQuantity} />
      <CartGiftLineQuantityAdjustButton
        adjust="increase"
        className={styles.button}
        onQuantityChange={onQuantityChange}
      >
        <Icon className={styles.icon} name="plus" />
      </CartGiftLineQuantityAdjustButton>
    </div>
  );
};

export const CartItemQuantitySelectorView = memo(
  CartItemQuantitySelectorViewBase
);
